import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtErr } from "@/lib/api";
import { toast } from "sonner";

export function PaymentSuccess() {
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries++ > 8) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
  }, []);
  return (
    <div className="min-h-screen marketing-bg flex items-center justify-center px-5">
      <div className="bg-white border border-[#E2E8F0] rounded-2xl p-10 max-w-md text-center" data-testid="payment-status">
        {status === "checking" && <p className="text-[#5C6B73]">Confirming your payment…</p>}
        {status === "paid" && <><h1 className="font-display text-2xl font-bold text-[#0B132B]">Payment successful</h1><p className="mt-2 text-[#5C6B73]">Your account has been updated.</p></>}
        {status === "pending" && <p className="text-[#5C6B73]">Payment is processing. Check back shortly.</p>}
        {status === "error" && <p className="text-[#5C6B73]">We couldn't confirm this payment.</p>}
        <div className="mt-6 flex gap-3 justify-center">
          <a href="/billing" className="inline-block bg-[#0B132B] text-white px-6 py-2.5 rounded-full font-medium">Billing &amp; Credits</a>
          <a href="/dashboard" className="inline-block border border-[#0B132B]/20 text-[#0B132B] px-6 py-2.5 rounded-full font-medium">Dashboard</a>
        </div>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen marketing-bg flex items-center justify-center px-5">
      <div className="bg-white border border-[#E2E8F0] rounded-2xl p-10 max-w-md text-center">
        <h1 className="font-display text-2xl font-bold text-[#0B132B]">Payment cancelled</h1>
        <a href="/dashboard" className="mt-6 inline-block bg-[#0B132B] text-white px-6 py-2.5 rounded-full font-medium">Back to dashboard</a>
      </div>
    </div>
  );
}
